import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {getAllActiveCategories} from '../../fetch/categoryApi';
import {CategoryType} from '../../types/CategoryType';
import {CategoryName} from '../../types/enums/CategoryName';
import {AppDispatch} from '../../store';

export interface CategoryState {
    categories: CategoryType[];
    dfbCupCategory?: CategoryType;
    bundesliga?: CategoryType;
}

const initialState: CategoryState = {
    categories: []
};

const categorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {
        categoriesSet: (state, action: PayloadAction<CategoryType[]>) => {
            state.categories = action.payload;
            state.dfbCupCategory = action.payload?.find(category => category.name === CategoryName.DFB_POKAL);
            state.bundesliga = action.payload?.find(category => category.name === CategoryName.BUNDESLIGA);
        }
    }
});

export const {categoriesSet} = categorySlice.actions;
export default categorySlice.reducer;

export const loadCategories = () => (dispatch: AppDispatch) => {
    getAllActiveCategories(dispatch).then((response) => {
        if (response.success) {
            dispatch(categoriesSet(response.result));
        }
    });
};
